'use strict';

/* globals config, socket, app, $ */

require([
	config.relative_path + '/plugins/nodebb-plugin-ideas-board/static/vendor/vue.js',
	'benchpress',
	'translator',
	'bootbox',
], function (Vue, Benchpress, translator, bootbox) {
	var internals = {
		howManyCommentsToLoad: 10,
	};

	Vue.component('note-comments', {
		props: ['note'],
		data: function () {
			return {
				shared: internals.shared,
			};
		},
		methods: {
			showComments: function () {
				var _this = this;

				internals.showCommentsModal(this.note.noteId, this.note.commentsCount, function () {
					_this.note.commentsCount += 1;
				});
			},
		},
		template: '<button v-on:click="showComments()" class="btn btn-link"><small>Comments: {{note.commentsCount}}</small></button>',
	});

	internals.showCommentsModal = function (noteId, commentsCount, onCommentAdded) {
		var loadedCount = internals.howManyCommentsToLoad;

		Benchpress.parse('board/note-comments-modal', { noteId }, function (html) {
			bootbox.dialog({
				title: '[[ideas-board:note-comments]]',
				message: html,
				size: 'large',
				buttons: {
					cancel: {
						label: '[[modules:bootbox.cancel]]',
						className: 'btn-link',
					},
				},
			});

			internals.loadComments(noteId, 0, commentsCount > loadedCount, 'prepend');
			internals.scrollComments();

			$('#add-comment').click(function () {
				internals.addComment(noteId, onCommentAdded);
			});

			$('#load-more').click(function () {
				var newLoadedCount = loadedCount + internals.howManyCommentsToLoad;

				internals.loadComments(noteId, loadedCount, commentsCount > newLoadedCount, 'prepend');

				loadedCount = newLoadedCount;
			});
		});
	};

	internals.loadComments = function (noteId, skipCount, showLoadMore, insertMethod) {
		socket.emit('plugins.ideasBoard.getNoteComments', { noteId, skipCount }, function (err, comments) {
			if (err) {
				return app.alertError(err.message);
			}

			$.each(comments, function (index, comment) {
				internals.renderComment(comment, insertMethod);
			});

			if (!showLoadMore) {
				$('.load-more').hide();
			}
		});
	};


	internals.renderComment = function (comment, insertMethod) {
		Benchpress.parse('partials/note-comment', { comment }, function (html) {
			translator.translate(html, function (html) {
				$('.comments-list')[insertMethod](html);
				$('.timeago').timeago();
			});
		});
	};

	internals.addComment = function (noteId, onCommentAdded) {
		var content = $('#comment-content').val();

		if (!content.length) {
			return translator.translate('[[ideas-board:comment-content-required]]', function (msg) {
				return app.alertError(msg);
			});
		}

		socket.emit('plugins.ideasBoard.addNoteComment', { noteId, content }, function (err, comment) {
			if (err) {
				return app.alertError(err.message);
			}

			internals.renderComment(comment, 'append');
			internals.scrollComments();
			$('#comment-content').val('');

			onCommentAdded();
		});
	};

	internals.scrollComments = function () {
		setTimeout(function () {
			$('.note-comments').scrollTop(function () { return this.scrollHeight; });
		}, 250);
	};
});
